import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import {BrowserRouter, Route, Routes} from "react-router-dom";

if (window.location.host === "api.stg.atlassian.com"
    || window.location.host === "api.atlassian.com"
    || window.location.host === "api-private.stg.atlassian.com"
    || window.location.host === "api-private.atlassian.com") {
    if (window.confirm(`${window.location.host} does not support authentication\n\nRedirect to replacement?`)) {
        if (window.location.host.indexOf(".stg.") >= 0) {
            window.location = "https://team.stg.atlassian.com/gateway/api/graphql";
        } else {
            window.location = "https://team.atlassian.com/gateway/api/graphql";
        }
    }
}

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
    <BrowserRouter>
        <Routes>
            {/* exact routes come here */}
            <Route path="*" element={<App/>}/>
        </Routes>
    </BrowserRouter>
);
